import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../index';
import { EditorState } from '../../slices/editor';

export const selectActiveCampaign = (): any =>
    createSelector(
        (state: RootState) => state.editor,
        (state: EditorState) => state.campaign,
    );
